import { types } from 'actions/enrichmentWizard';
import { stepNumbers } from 'components/DataEnrichment/Wizards';

const defaultState = {
  file: null,
  data: [],
  mappings: {
    email: {
      column: null,
      userAction: false,
      validation: {
        valid: [],
        total: 0,
        invalid: [],
      },
    },
    organisation: {
      column: null,
      userAction: false,
      validation: {
        valid: [],
        total: 0,
        invalid: [],
      },
    },
  },
  settings: {
    includeHeaders: true,
  },
  currentStep: 0,
  enrichmentStatus: null,
  listName: '',
  dataEnrichmentId: null,
  sheetName: '',
  type: 'email',
  error: null,
};

const REDUCER = {
  [types.SET_FILE]: (state, action) => ({
    ...state,
    file: action.payload,
  }),
  [types.SET_DATA]: (state, action) => ({
    ...state,
    data: action.payload,
  }),
  [types.UPDATE_MAPPING]: (state, action) => ({
    ...state,
    mappings: {
      ...state.mappings,
      [action.payload.mappingId]: {
        ...state.mappings[action.payload.mappingId],
        ...action.payload.update,
      },
    },
  }),
  [types.SET_WIZARD_STEP]: (state, action) => ({
    ...state,
    currentStep: action.payload,
  }),
  [types.INCREMENT_WIZARD_STEP]: state => ({
    ...state,
    currentStep: state.currentStep + 1,
  }),
  [types.DECREMENT_WIZARD_STEP]: state => ({
    ...state,
    currentStep: state.currentStep - 1,
  }),
  [types.RESET_WIZARD_STEP]: state => ({
    ...state,
    currentStep: 0,
  }),
  [types.SET_ENRICHMENT_STATUS]: (state, action) => ({
    ...state,
    enrichmentStatus: action.payload,
  }),
  [types.RESET_WIZARD_STATE]: (state, action) => ({
    ...defaultState,
    type: action.payload.type,
    dataEnrichmentId: action.payload.summaryId,
    currentStep: action.payload.summaryId
      ? action.payload.isProcessing
        ? stepNumbers.enrichment
        : stepNumbers.summary
      : 0,
    enrichmentStatus: action.payload.isProcessing ? 'processing' : null,
  }),
  [types.PROCESS_DATA_ENRICHMENT]: (state, action) => ({
    ...state,
    enrichmentStatus:
      state.dataEnrichmentId === action.payload
        ? 'complete'
        : state.enrichmentStatus,
  }),
  [types.RESTORE_STATE]: (state, action) => {
    if (!action.payload) {
      return {
        ...defaultState,
        ...state,
      };
    }

    let restoredState = JSON.parse(JSON.stringify(action.payload));
    restoredState = {
      ...defaultState,
      ...restoredState,
    };
    return restoredState;
  },
  [types.UPDATE_SETTINGS]: (state, action) => ({
    ...state,
    settings: {
      ...state.settings,
      ...action.payload,
    },
  }),
  [types.SET_LIST_DETAILS]: (state, action) => ({
    ...state,
    listDetails: { ...action.payload },
  }),
  [types.RESET_MAPPINGS]: state => ({
    ...state,
    mappings: {
      ...defaultState.mappings,
    },
  }),
  [types.SET_SHEET_NAME]: (state, action) => ({
    ...state,
    sheetName: action.payload,
  }),
  [types.SET_ENRICHMENT_TYPE]: (state, action) => ({
    ...state,
    type: action.payload,
  }),
  [types.SET_DATA_ENRICHMENT_ID]: (state, action) => ({
    ...state,
    dataEnrichmentId: action.payload,
  }),
  [types.SET_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
  }),
};

const reducer = (state = defaultState, action) => {
  const handler = REDUCER[action.type];
  return handler ? handler(state, action) : state;
};

export default reducer;
